import { ShortContentCompletedVideoView, useShortFromPropsOrParams } from '..';
import { VideoPlayerWithControls } from '../../video';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentVideo = props => {
  const {
    short,
    language,
    playlistId
  } = useShortFromPropsOrParams(props);
  if (!short) return null;
  const {
    name,
    contentId
  } = short;
  return /*#__PURE__*/_jsx(VideoPlayerWithControls, {
    completedVideoView: /*#__PURE__*/_jsx(ShortContentCompletedVideoView, {}),
    language: language,
    playlistId: playlistId,
    shortId: contentId,
    shortName: name
  });
};
export default ShortContentVideo;